import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'lib-error-page',
  imports: [NzIconModule, NzFlexModule, TranslatePipe],
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent {

}
